import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Dispo.html?raw';

import GridStack from 'gridstack/dist/gridstack-all'; // npm-install ausführen, gridstack unter scripts/src erneuern aus zip
import Container from './DispoSections/Bottom/Container';
import ItemTableView from './DispoSections/ItemTableView/ItemTableView';
import DateInput from '../../../moreCore/UI/DateInput/DateInput';
import "../../../moreCore/UI/DateInput/DateInput";

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/CheckBox/CheckBox";
import CreateStageForm from './DispoSections/CreateStageForm/CreateStageForm';

class TiDispo extends compose(_WidgetBaseSP) {
    templateString: any = template;

    grid: GridStack.GridStack;
    dispoDate: MdsLax<InstanceType<typeof DateInput>>;
    dispoDivision: MdsLax<InstanceType<typeof SelectBox>>;
    map: any;
    mapSourceToggle: MdsLax<InstanceType<typeof CheckBox>>;
    lastSelectedGood: null;

    mapTargetNodeId: string = "top_1";

    table_trucks: MdsLax<InstanceType<typeof ItemTableView>>;
    table_goods: MdsLax<InstanceType<typeof ItemTableView>>;
    createStageForm: MdsLax<InstanceType<typeof CreateStageForm>>;

    private _initGrid(): void {

        let sub1 = [
            { x: 0, y: 0, w: 3, h: 6, content: `<div id="top_0"></div>` }, { noMove: false, y: 0, w: 2, h: 6, content: `<div id="${this.mapTargetNodeId}" style="height: 100%; width: 100%; visibility: hidden;"></div>` }, { y: 0, w: 7, h: 6, content: `<div id="top_2"></div>` },
            { y: 0, w: 12, h: 2, locked: true, content: `<div id="middle"></div>` },
            { y: 0, w: 12, h: 6, locked: true, content: `<div id="bottom_0"></div>` }
        ];


        //let count = 0;
        //[...sub1, ...sub2].forEach(d => d["content"] = String(count++));

        let subOptions = {
            cellHeight: 50, // should be 50 - top/bottom
            column: 'auto', // size to match container. make sure to include gridstack-extra.min.css
            acceptWidgets: true, // will accept .grid-stack-item by default
            margin: 4,
        };


        //console.log(sub1);
        let options = { // main grid options
            cellHeight: 50,
            margin: 5,
            minRow: 3, // don't collapse when empty
            disableOneColumnMode: false,
            acceptWidgets: true,
            id: 'main',
            children: [
                { noMove: true, x: 0, y: 0, w: 12, h: 16, subGridOpts: { children: sub1, id: 'sub1_grid', class: 'sub1', ...subOptions } }
            ]
        };

        this.grid = (GridStack as any).addGrid(document.querySelector('.container-fluid'), options);


        //  Etappen
        //
        let tabContainerBottom = new Container();
        tabContainerBottom.placeAt(document.getElementById("bottom_0"));

        // LKWs
        //
        this.table_trucks = new ItemTableView();
        this.table_trucks.url = window.appRoot + "TransportIntermodal/GetDispoTrucks";
        this.table_trucks.loadDataResponse({
            dispoDate: this.dateToLocalISOString(this.dispoDate.getValue()),
            divisionId: this.dispoDivision.getValue()
        });
        this.table_trucks.placeAt(document.getElementById("top_0"));

        this.table_trucks.on("RowClick", lang.hitch(this, this._onRowClick__Truck));

        //  Transportgüter
        //
        this.table_goods = new ItemTableView();
        this.table_goods.url = window.appRoot + "TransportIntermodal/GetDispoTransportGoods";
        this.table_goods.loadDataResponse({});
        this.table_goods.placeAt(document.getElementById("top_2"));

        this.table_goods.on("RowClick", lang.hitch(this, this._onRowClick__TransportGood));

        // MAP
        //
        this.initializeMap();

        //  Etappen-Form
        //
        this.createStageForm = new CreateStageForm();
        this.createStageForm.placeAt(document.getElementById("middle"));
    }

    private _onClick_ToggleMapSource() {
        
        this.displayGoodOnMap();
    }

    private _onRowClick__TransportGood(entity: any) {

        this.lastSelectedGood = entity;
        this.displayGoodOnMap();

        this.createStageForm.good_node.innerHTML = entity.displayname; //@TODO: typisieren
    }

    private _onRowClick__Truck(entity: any) {

        this.createStageForm.truck_node.innerHTML = entity.identification; //@TODO: typisieren
        this.createStageForm.cargo_hold_node.innerHTML = entity.identification; //@TODO: typisieren
    }

    private displayGoodOnMap() {
        let entity = this.lastSelectedGood as any;

        let center = [entity.latitude, entity.longitude]; //@TODO: typisieren
        let markerTitle = entity.ref_address_loading.displayname; //@TODO: typisieren

        let showTarget = this.mapSourceToggle.getValue();
        if (showTarget === true) {
            center = [entity.latitude_2, entity.longitude_2]; //@TODO: typisieren
            markerTitle = entity.c_address_unloading; //@TODO: typisieren
        }

        this.map.setView(center, 13);
        let leaflet = (window as any).L;
        leaflet.marker(center, { title: markerTitle }).addTo(this.map);

        this.UiModder.domStyle.set(document.getElementById(this.mapTargetNodeId), "visibility", "");
    }

    private _onChange_Division() {
        this.table_trucks.loadDataResponse({
            dispoDate: this.dateToLocalISOString(this.dispoDate.getValue()),
            divisionId: this.dispoDivision.getValue()
        });
    }

    private _loadDivisions() {

        this.RequestManager.get(window.appRoot + "TransportIntermodal/GetDivisions",
            lang.hitch(this, this._onResponse__loadDivisions),
            lang.hitch(this, this._onError__loadDivisions)
        );

    }

    private _onResponse__loadDivisions(data: Array<object>) {
        console.log("_onResponse__loadDivisions", data);
        this.dispoDivision.setData(null,
            data,
            "ID",
            "displayname"
        );

        //this.dispoDivision.emitChangeEvent();
    }

    initializeMap() {
        let leaflet = (window as any).L;

        let map = leaflet.map(this.mapTargetNodeId);
        leaflet.tileLayer(
            'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18
        }).addTo(map);        

        this.map = map;
    }

    private _onError__loadDivisions(error: any) {

    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);

        this.translations["TiDispo__MainTitle"] = "Dispo";
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this._loadDivisions();
        this._initGrid();
        this.dispoDate.setValue(new Date());
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    }


    /*demoData_2: object = {
        "entityList": [
            {
                "ID": "000000e9:0023c50a",
                "Classname": "trailer",
                "S": "n",
                "Typ": "KL",
                "LDM": "12,00 LDM",
                "Address": "Rondo Ganahl, Rotfarbweg 1, 6820 Frastanz, Österreich"
            },
            {
                "ID": "000000e9:0023c50a",
                "Classname": "trailer",
                "S": "n",
                "Typ": "KL",
                "LDM": "12,00 LDM",
                "Address": "more dimensions GmbH, Zeller Berg 2, 6330 Kufstein, Österreich"
            }, {
                "ID": "000000e9:0023c50a",
                "Classname": "trailer",
                "S": "n",
                "Typ": "KL",
                "LDM": "12,00 LDM",
                "Address": "Outlet Center Brenner, Via San Valentino 9/A, 39041 Brennero, Italien"
            }, {
                "ID": "000000e9:0023c50a",
                "Classname": "trailer",
                "S": "n",
                "Typ": "KL",
                "LDM": "12,00 LDM",
                "Address": "Binderholz GmbH, Zillertalstraße 39, 6263 Fügen, Österreich"
            }
        ],
        "tableLayouts": [
            {
                "rows": [
                    {
                        "attributes": [
                            "S",
                            "Typ",
                            "LDM",
                            "Address"
                        ],
                        "headings": [
                            "S",
                            "Typ",
                            "LDM",
                            "Adresse (Beladung)"
                        ],
                        "colspans": [
                            1,
                            1,
                            1,
                            1
                        ],
                        "widths": [
                            "25%",
                            "25%",
                            "25%",
                            "25%"
                        ],
                        "colNamesInternal": [
                            "S",
                            "Typ",
                            "LDM",
                            "Address"
                        ],
                        "bgColors": [
                            "",
                            "",
                            "",
                            ""
                        ],
                        "txtColors": [
                            "",
                            "",
                            "",
                            ""
                        ]
                    }
                ],
                "name": "default",
                "label": "Standard"
            }
        ]
    };*/
}

export default mdsWidget(TiDispo);